import React from 'react';
import { Link } from 'react-router-dom';
import { FadeIn } from '../FadeIn';
import { CheckCircle2, ArrowRight } from 'lucide-react';
export function AboutMeHome() {
  const missions = ['De la epuizare la claritate și direcție', 'De la lipsa de validare la încredere autentică', 'De la tipare repetitive la o viață care te reprezintă'];
  const PhotoCard = <div className="relative max-w-[380px] mx-auto lg:mx-0" data-id="element-485">
      <div className="rounded-[24px] overflow-hidden shadow-xl aspect-[3/4] border-4 border-gold/30" data-id="element-486">
        <img src="https://cdn.magicpatterns.com/uploads/bbhRnscRmaZkzuZMMer6an/Foto_1.jpg" alt="Mihaela Iovu" className="w-full h-full object-cover object-center" data-id="element-487" />
      </div>
    </div>;
  return <section className="py-16 md:py-24 bg-ivory overflow-hidden relative" data-id="element-488">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gold/5 rounded-l-full blur-3xl pointer-events-none" data-id="element-489"></div>

      <div className="max-w-[1200px] mx-auto px-6 md:px-8 relative z-10" data-id="element-490">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 lg:items-center" data-id="element-491">
          {/* Photo - desktop left side */}
          <div className="hidden lg:block lg:col-span-5" data-id="element-492">
            <FadeIn direction="left" data-id="element-493">{PhotoCard}</FadeIn>
          </div>

          {/* Content column. Mobile order: title → photo → text → mission → button */}
          <div className="lg:col-span-7" data-id="element-494">
            <FadeIn data-id="element-495">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-8 text-center lg:text-left leading-tight" data-id="element-496">
                Ghidare către încredere și aliniere interioară
              </h2>
            </FadeIn>

            {/* Photo inline on mobile only — between title and text */}
            <div className="lg:hidden mb-8" data-id="element-497">
              <FadeIn data-id="element-498">{PhotoCard}</FadeIn>
            </div>

            <FadeIn delay={0.1} data-id="element-499">
              <div className="space-y-5 text-charcoal/80 font-sans text-[19px] leading-relaxed mb-10" data-id="element-500">
                <p data-id="element-501">
                  Sunt Mihaela Iovu și lucrez cu femei de carieră 30+ care au
                  construit vieți care funcționează în exterior, dar care în
                  interior nu le mai reprezintă.
                </p>
                <p data-id="element-502">
                  Prin metoda A.R.I.S.E. le ghidez să iasă din epuizare și să se
                  reconecteze cu cine sunt cu adevărat, dincolo de roluri și
                  adaptări.
                </p>
                <p data-id="element-503">
                  Integrez NLP, constelații familiale, hipnoză și coaching
                  profund într-un proces structurat, aplicat pe viața reală. Nu
                  lucrez doar cu mintea. Lucrez cu tot ce stă în spatele
                  blocajului.
                </p>
              </div>
            </FadeIn>

            {/* Misiunea mea */}
            <FadeIn delay={0.2} data-id="element-504">
              <div className="bg-white/60 border border-gold/20 rounded-[24px] p-8 md:p-10 shadow-sm" data-id="element-505">
                <h3 className="text-2xl font-serif font-medium text-forest mb-6" data-id="element-506">
                  Misiunea mea
                </h3>
                <ul className="space-y-4" data-id="element-507">
                  {missions.map((mission, index) => <li key={index} className="flex items-start gap-4" data-id="element-508">
                      <div className="mt-1 bg-gold/20 rounded-full p-0.5 shrink-0" data-id="element-509">
                        <CheckCircle2 className="w-5 h-5 text-gold-dark" strokeWidth={2.5} data-id="element-510" />
                      </div>
                      <span className="text-[18px] text-charcoal/80 font-sans leading-relaxed" data-id="element-511">
                        {mission}
                      </span>
                    </li>)}
                </ul>
              </div>
            </FadeIn>

            {/* CTA button to Despre Mine page */}
            <FadeIn delay={0.3} data-id="element-512">
              <div className="mt-10 flex justify-center lg:justify-start" data-id="element-513">
                <Link to="/despremine" className="inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-forest text-ivory font-display font-medium text-[17px] hover:bg-forest-dark transition-all duration-300 shadow-lg hover:-translate-y-1 no-underline" data-id="element-514">
                  Află mai multe despre mine
                  <ArrowRight className="w-5 h-5" data-id="element-515" />
                </Link>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}